import { render } from "./_Editar.vue?vue&type=template&id=d527282c"
import script from "./_Editar.vue?vue&type=script&lang=ts"
export * from "./_Editar.vue?vue&type=script&lang=ts"
script.render = render

export default script